import React, { useEffect, useState } from "react";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import IconButton from "@mui/material/IconButton";
import { Box, Grid, Stack } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from "react-router";
import { axiosFetch } from "../../../utils/AxiosFetch";
import CircularProgress from "@mui/material/CircularProgress";
import { TextEditor } from "../../../shared/index";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { SnackbarActions } from '../../../redux/actions/snackbar.actions'
import { useDispatch } from "react-redux";


function About(props) {
  var dispatch = useDispatch()
  let value = EditorState.createEmpty();
  var editorContent = value;
  var contentState = props.profile.description;
  if (contentState === "" || contentState === null) {
    editorContent = value;
  } else {
    var content = convertFromHTML(contentState);
    var aboutContent = ContentState.createFromBlockArray(
      content.contentBlocks,
      content.entityMap
    );
    editorContent = EditorState.createWithContent(aboutContent);
    // console.log(editorContent)
  }
  const [editorState, setEditorState] = useState(editorContent);
  const navigate = useNavigate();
  let [isEditable, setIsEditable] = useState(true);
  let [about, setAbout] = useState(props.profile.description);
  let [loading, setLoading] = useState(false);
  // console.log(props.Id);
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  useEffect(() => {
    var contentState = props.profile.description;
    if (contentState === "" || contentState === null) {
      editorContent = value;
    } else {
      var content = convertFromHTML(contentState);
      var aboutContent = ContentState.createFromBlockArray(
        content.contentBlocks,
        content.entityMap
      );
      editorContent = EditorState.createWithContent(aboutContent);
    }
    setEditorState(editorContent)
  }, [props.profile.description])

  const updateDetails = () => {
    setLoading(true);
    var req = {
      TypeId: 1,
      FieldName: "description",
      Value: about,
      ItemId: props.Id,
      TableName: "EmployeeDetails",
    };
    axiosFetch({
      method: "POST",
      url: "/data/update",
      requestConfig: req,
    })
      .then((res) => {

        if (res.status === 200) {
          if (res.data === "success") {
            setLoading(false);
            setIsEditable(true);
            dispatch(SnackbarActions(true, "success", "Updated successfully"))
          }
        }
        if (res.status === 400) {
          setLoading(false);
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleStateChange = (editorstate) => {
    setEditorState(editorstate);
    var markupContent;
    const rawContentState = convertToRaw(editorState.getCurrentContent());
    markupContent = draftToHtml(rawContentState);
    setAbout(markupContent);
  };
  const isValidLength = (contentState) => {
    const maxLength = 1000;
    return contentState.getPlainText("").length <= maxLength;
  };

  const handleBeforeInput = () => {
    // if (!isValidLength(editorState.getCurrentContent())) {
    //   return "handled";
    // }
  }
  return (
    <div>
      {/* {props.profile !== null ?( */}
      <Box>
        <Grid container className="about-us">
          <Grid item xs={5}>
            <h3 className="about-me">About Me</h3>
          </Grid>
          <Grid item xs={1}>
            {loading ? (
              <Stack sx={{ color: "grey.500" }} spacing={2} direction="row">
                <CircularProgress color="success" size="2rem" />
              </Stack>
            ) : (
              ""
            )}
          </Grid>
          {(isUserLogged.useremail === props.profile.emailId || isUserLogged.usertype === "Admin" ||
            isUserLogged.usertype === "SuperAdmin"
            || isUserLogged.usertype === "HRManager"
            || ((isUserLogged.usertype === "HR" && props.profile.userType !== "HRManager")
              && (isUserLogged.usertype === "HR" && props.profile.userType !== "SuperAdmin") &&
              (isUserLogged.usertype === "HR" && props.profile.userType !== "Admin"))
          ) ?
            <Grid
              item
              xs={6}
              alignItems="right"
              display="flex"
              justifyContent="right"
            >
              {isEditable === false ? (
                <>
                  <IconButton
                    sx={{ color: "red" }}
                    aria-label="save"
                    onClick={() => setIsEditable(true)}
                  >
                    <CancelIcon />
                  </IconButton>
                  <IconButton
                    color="success"
                    aria-label="save"
                    onClick={() => updateDetails()}
                  >
                    <CheckCircleIcon />
                  </IconButton>
                </>
              ) : (
                <IconButton
                  className="stensil-ignore"
                  aria-label="edit"
                  size="small"
                  onClick={() => setIsEditable(false)}
                >
                  <ModeEditIcon className="theme-icon" fontSize="inherit" />
                </IconButton>
              )}
            </Grid> : ""}
          <Grid item xs={12} className="stensil-para">
            <TextEditor
              readOnly={isEditable}
              toolbarHidden={isEditable}
              editorValue={editorState}
              // content={about}
              onEditorStateChange={handleStateChange}
              handleBeforeInput={handleBeforeInput}
              handlePastedText={handleBeforeInput}
            />
          </Grid>
          {/* <Grid item xs={12}>
            {isEditable ? (
              <Box
                sx={{
                  "& .MuiTextField-root": { minWidth: "100%" },
                }}
                autoComplete="off"
              >
                <TextField
                  multiline
                  notchedOutline="none"
                  style={{marginTop: "20px"}}
                  value={about}
                  onChange={(e)=>setAbout(e.target.value)}
                />
                
              </Box>
            ) : (
              <p id="about" className="stensil-para">
                {about}
              </p>
            )}
          </Grid> */}
        </Grid>
      </Box>
      {/* ):(
        ""
      )} */}
    </div>
  );
}
export default About;
